import { render, staticRenderFns } from "./TheProfile.vue?vue&type=template&id=363b269e&scoped=true"
import script from "./TheProfile.vue?vue&type=script&lang=js"
export * from "./TheProfile.vue?vue&type=script&lang=js"
import style0 from "./TheProfile.vue?vue&type=style&index=0&id=363b269e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363b269e",
  null
  
)

export default component.exports